import React from 'react';

import PropTypes from 'prop-types';
import { useCSVReader } from 'react-papaparse';
import {useDispatch} from "react-redux";
import {createElementsFromCsv} from "../../../store/product/productElementsSlice";
import ImportFeedback from "./ImportFeedback";
import {setImportFeedback} from "../../../store/configuratorStateSlice";

const ImportModal = (props) => {
    if(!props.open){
        return null;
    }
    const dispatch = useDispatch();
    const { CSVReader } = useCSVReader();
    const styles = {
        wrapper: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 9999,
        },
        content: {
            position:'relative',
            width: '50%',
            height: '400px',
            transform: 'translate(50%, 50%)',
            backgroundColor: 'white',
            boxShadow: '5px 5px 20px black',
            padding: '25px',
            zIndex: 10000
        },
        csvReader: {
            display: 'flex',
            flexDirection: 'row',
            marginBottom: 10,
            marginTop: 20,
            justifyContent: 'center'
        } ,
        acceptedFile: {
            border: '1px solid #ccc',
            height: 40,
            lineHeight: 2.5,
            margin: '0 10px',
            width: '60%',
        },
        progressBarBackgroundColor: {
            backgroundColor: 'red',
        },
        close: {
            top: '15px',
            right: '15px',
            position: 'absolute',
        }
    }

    const handleWrapperClick = (e) => {
        if(e.target.className == 'wrapper') {
            props.closeModal()
        }
    }

    return (
        <div className='wrapper' style={styles.wrapper} onClick={(e) => handleWrapperClick(e)}>
            <div>close</div>
            <div className="modal-content" style={styles.content}>
                <h5 style={{textAlign: 'center'}}> This will delete any elements you have already created</h5>
                <div style={{textAlign: 'center'}}>This import expects the following columns to exist: ID, Fam Code, and Section</div>
                <div onClick={() => props.closeModal()} style={styles.close}><i className={'fa fa-close fa-2x'}/></div>
                <CSVReader
                    onUploadAccepted={(results) => {
                        dispatch(setImportFeedback([]))
                        dispatch(createElementsFromCsv(results))
                    }}
                    config={{
                        header: true
                    }}
                >
                    {({
                          getRootProps,
                          acceptedFile,
                          ProgressBar,
                          getRemoveFileProps,
                      }) => (
                        <>
                            <div style={styles.csvReader}>
                                <button className='button no-chevron' type='button' {...getRootProps()} >
                                    Browse file
                                </button>
                                <div style={styles.acceptedFile}>
                                    {acceptedFile && acceptedFile.name}
                                </div>
                                <button {...getRemoveFileProps()} className={'button no-chevron'}>
                                    Remove
                                </button>
                            </div>
                            <ProgressBar style={styles.progressBarBackgroundColor} />
                        </>
                    )}
                </CSVReader>
                <ImportFeedback />
            </div>
        </div>
    )
};

ImportModal.Proptypes = {
    open: PropTypes.bool.isRequired
}

export default ImportModal;